// src/utils/models/switchClientModel.js

export const SWITCH_STATUS = {
  PENDING: 'pending',
  ACTIVE: 'active',
  NO_SAVINGS: 'no_savings',
  DESERTER: 'deserter'
};

export const SWITCH_STATUS_LABELS = {
  pending: 'Pendiente',
  active: 'Activo',
  no_savings: 'Sin ahorro',
  deserter: 'Desertor'
};

export const SWITCH_STATUS_COLORS = {
  pending: '#9E9E9E',      // Gris
  active: '#4CAF50',        // Verde
  no_savings: '#FF9800',    // Naranja
  deserter: '#F44336'       // Rojo
};